import script from "./BssMovementLayoutChanger.vue?vue&type=script&lang=ts&setup=true"
export * from "./BssMovementLayoutChanger.vue?vue&type=script&lang=ts&setup=true"

import "./BssMovementLayoutChanger.vue?vue&type=style&index=0&id=41672390&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41672390"]])

export default __exports__